// This file is for constants

"use strict";

/**
 * Name of the header to provide
 * the session token for the server API
 */
export const SESSION_TOKEN_HEADER_NAME = "x-session-token";

/**
 * Type value for images
 */
export const MEDIA_TYPE_IMAGE = 1;

/**
 * Type value for videos
 */
export const MEDIA_TYPE_VIDEO = 2;

/**
 * Type value for audios
 */
export const MEDIA_TYPE_AUDIO = 3;

/**
 * Delay to retry loading after an error
 */
export const LOAD_RETRY_DELAY = 1500;

/**
 * Delay to display a loader
 */
export const LOADER_DISPLAY_DELAY = 330;
